module.exports = __webpack_public_path__ + "img/receipt37.3b661722.svg";